module.exports = __webpack_public_path__ + "static/img/agb_2.87520fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/agb_2.png
// module id = 1252
// module chunks = 1